import { GlBadge, GlIcon, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, n__ } from '~/locale';
export default {
    name: 'ApprovalCount',
    components: {
        GlBadge,
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        mergeRequest: {
            type: Object,
            required: true
        },
        fullText: {
            type: Boolean,
            required: false,
            default: false
        },
        /**
     * Renders a subtle icon and count instead of the badge, for dense lists where a
     * coloured pill would compete with the merge request title for attention.
     */ neutral: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        approvalCount () {
            if (this.fullText && this.mergeRequest.approvedBy.nodes.length) {
                return __('Approved');
            }
            return this.mergeRequest.approvedBy.nodes.length;
        },
        tooltipTitle () {
            return n__('%d approval', '%d approvals', this.mergeRequest.approvedBy.nodes.length);
        }
    }
};
